// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"Banner_alertContainer__Zzq4c","alert":"Banner_alert__3a1dW","closebtn":"Banner_closebtn__2F-1y","warningIcon":"Banner_warningIcon__2i4D2"};